import React, { useState } from 'react';
import Accordian from '../../components/Accordian/Accordian';
import Subcategory from './Subcategory';
import Loader from 'examples/Loader';
import { useAgencyInfo } from 'context/agency';
import Swal from 'sweetalert2';
import Prompts from './Prompts';
import { usePartnerTasks } from 'queries/prompts';

function CustomPrompt({ custompromptcreateModel, openModelView, refresh }) {
  const [agency, , , agencyConfig, UpdateAgencyConfig] = useAgencyInfo();

  const {
    data: promptuncategories = {},
    isLoading: loader,
    isFetching,
    refetch: getcategory_Cat,
  } = usePartnerTasks({ agencyId: agency?._id, type: 'agency' });

  const [roleFilter, setRoleFilter] = useState('all');
  const [sectorFilter, setSectorFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  // Flatten all prompts into one list
  const allPrompts = Object.values(promptuncategories).flat();

  return (
    <div>
      {loader === false && !isFetching ?
        <div style={{ position: "relative" }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            marginBottom: "20px",
            paddingRight: "10px"
          }}>
            <div style={{ display: 'flex', gap: '15px' }}>
              <select
                className="selectstyle"
                style={{ minWidth: '150px', padding: '10px', borderRadius: '8px' }}
                value={roleFilter}
                onChange={(e) => setRoleFilter(e.target.value)}
              >
                <option value="all">All Roles</option>
                {agency?.job_roles?.map(role => (
                  <option key={role._id || role.id} value={role._id || role.id}>{role.name}</option>
                ))}
              </select>

              <select
                className="selectstyle"
                style={{ minWidth: '150px', padding: '10px', borderRadius: '8px' }}
                value={sectorFilter}
                onChange={(e) => setSectorFilter(e.target.value)}
              >
                <option value="all">All Sectors</option>
                {agency?.sectors?.map(sector => (
                  <option key={sector._id || sector.id} value={sector._id || sector.id}>{sector.name}</option>
                ))}
              </select>
              <input
                type="text"
                placeholder="Search Partner Tasks"
                className="selectstyle"
                style={{ minWidth: '200px', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <button
              className="btn-new-design-black"
              onClick={custompromptcreateModel}
              style={{ padding: '10px 24px', borderRadius: '8px' }}
            >
              + Add Task
            </button>
          </div>

          <div style={{ marginTop: "20px" }}>
            <Prompts
              refresh={getcategory_Cat}
              initialSubcategory_prompts_Data={allPrompts}
              roleFilter={roleFilter}
              sectorFilter={sectorFilter}
              searchQuery={searchQuery}
            />
          </div>
        </div>
        : <Loader />}
    </div>
  );
}

export default CustomPrompt;
